<template>
    <div class="inner-menu container__menu">
        <template v-for="item in props.menuItem" :key="item">
            <router-link
                v-if="item.role.find(el => el === me.role)"
                class="inner-menu__item container__menu-item"
                active-class="container__menu-item--active"
                :to="item?.table
                    ? {name: item.routeName, query:{ offset: DEFAULT_TABLE_QUERY.currentPage, limit: DEFAULT_TABLE_QUERY.itemsPerPage }}
                    : {name: item.routeName}"
                rel="noopener noreferrer"
            >
                {{ $t(`${item.label}`) }}
            </router-link>
        </template>
    </div>
</template>

<script>
export default {
    name: 'UIContainerMenu',
};
</script>

<script setup>
import { inject } from 'vue';
import { DEFAULT_TABLE_QUERY } from '@/constants/default-variables';

const { me } = inject('me');

const props = defineProps({
    menuItem: { type: Array, default: () => []},
});
</script>
